<template>
    <div class="dashboard">
        <files-list :user-id="userId"></files-list>
    </div>
</template>

<script>
import FilesList from '@/components/Files/List.vue';

export default {
    name: 'files',

    metaInfo: {
        title: 'File backups - Weap.io',
    },

    components: {
        FilesList,
    },

    computed: {
        userId() {
            return localStorage.userId;
        },
    },
}
</script>
